import RouterSection from '@/components/layout/RouterSection'

export default {
  path: '/myapplication',
  name: 'myapplication-index',
  component: RouterSection,
  redirect: '/myapplication/list',
  children: [
    {
      path: 'list',
      name: 'myapplication-list',
      component: () => import('@/views/myapplication/MyApplicationList.vue')
    },
    {
      path: 'view/:seq',
      name: 'myapplication-view',
      component: () => import('@/views/myapplication/MyApplicationView.vue'),
      props : true
    },
    {
      path: 'view/:seq/:payment_history_seq/annuity',
      name: 'myapplication-view-payment-annuity',
      component: () => import('@/views/myapplication/MyApplicationView.vue'),
      props : true
    },
    {
      path: 'view/:seq/:payment_history_seq/fee',
      name: 'myapplication-view-payment-fee',
      component: () => import('@/views/myapplication/MyApplicationView.vue'),
      props : true
    },
    {
      path: 'submitmissingdocument/step1/:receipt_no',
      name: 'myapplication-submit-missing-document-step1',
      component: () => import('@/views/myapplication/SubmitMissingDocumentStep1.vue'),
      props : true
    },
    {
      path: 'submitmissingdocument/step2/:receipt_no',
      name: 'myapplication-submit-missing-document-step2',
      component: () => import('@/views/myapplication/SubmitMissingDocumentStep2.vue'),
      props : true
    },
    {
      path: 'requestappeal/step1/:receipt_no',
      name: 'myapplication-request-appeal-step1',
      component: () => import('@/views/myapplication/RequestAppealStep1.vue'),
      props : true
    },
    {
      path: 'requestappeal/step2/:receipt_no',
      name: 'myapplication-request-appeal-step2',
      component: () => import('@/views/myapplication/RequestAppealStep2.vue'),
      props : true
    },
    {
      path: 'submitamendment/step1/:receipt_no',
      name: 'myapplication-submit-amendment-step1',
      component: () => import('@/views/myapplication/SubmitamendmentStep1.vue'),
      props : true
    },
    {
      path: 'submitamendment/step2/:receipt_no',
      name: 'myapplication-submit-amendment-step2',
      component: () => import('@/views/myapplication/SubmitamendmentStep2.vue'),
      props : true
    },
  ]
}
